import { render } from "./BomValidationResultsElementsAmbiguousOldVersion.vue?vue&type=template&id=22d46822&scoped=true"
import script from "./BomValidationResultsElementsAmbiguousOldVersion.vue?vue&type=script&lang=js"
export * from "./BomValidationResultsElementsAmbiguousOldVersion.vue?vue&type=script&lang=js"

import "./BomValidationResultsElementsAmbiguousOldVersion.vue?vue&type=style&index=0&id=22d46822&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d46822"]])

export default __exports__